import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=432bce98&scoped=true&"
import script from "./TabContent.vue?vue&type=script&lang=js&"
export * from "./TabContent.vue?vue&type=script&lang=js&"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=432bce98&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432bce98",
  null
  
)

export default component.exports